<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    @if(parent_site_id) {
      <button mat-raised-button [routerLink]="'/sites/' + parent_site_id + '/children'" class="m-1 mr-2">
        <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
      </button>
    }

    @if(site_id) {
      <!-- Edit/View toggle: only users who can edit (Sites Edit + Sites: EEP Edit) can switch modes. -->
      @if(canEditEep) {
        <button mat-raised-button [routerLink]="utils.prepareSiteRelatedLink(site_id, parent_site_id, (isViewMode ? 'edit' : 'view') + '/emergency-evacuation-plans')" class="m-1 mr-2">
          <mat-icon>{{ isViewMode ? 'edit' : 'visibility' }}</mat-icon>
          {{ isViewMode ? 'Edit' : 'View' }}
        </button>
      }

      <button mat-raised-button class="m-1 mr-2" (click)="onExportEmergencyEvacuationPlan()">
        <mat-icon>cloud_download</mat-icon> Export
      </button>
    }
  </span>
</nav>

@if(isViewMode) {
  <app-sites-eep-view></app-sites-eep-view>
} @else {
  <app-sites-eep-edit></app-sites-eep-edit>
}
